/**
 * i18n — lingua FISSATA AL BUILD via VITE_LOCALE (default 'it').
 *
 * Niente switch a runtime e NIENTE fallback en→it: in un build EN una chiave
 * mancante non deve trapelare in italiano — la completezza dei cataloghi è
 * garantita PRIMA del build da scripts/check-i18n.mjs (exit 1 se en.json non
 * copre le chiavi di it.json), che gira nei gate.
 *
 * Cataloghi: src/locales/{it,en}.json — un file per lingua, aree come oggetti
 * top-level (convenzione chiavi: area.contesto.nome, interpolazioni nominate
 * es. t('richieste.coda.giorni_fa', { giorni })).
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import it from './locales/it.json';
import en from './locales/en.json';

const locale = (import.meta.env.VITE_LOCALE as string | undefined) ?? 'it';

void i18n.use(initReactI18next).init({
  lng: locale,
  resources: {
    it: { translation: it },
    en: { translation: en },
  },
  fallbackLng: false,
  interpolation: {
    // React fa già l'escaping: senza questo i valori interpolati mostrerebbero
    // entità HTML (es. l'apostrofo) nel testo.
    escapeValue: false,
  },
  returnNull: false,
});

export default i18n;
